import { DateTime } from "luxon"
import { defineStore } from "pinia"
import { VueCookieNext } from "vue-cookie-next"

export interface State {
  cookies: boolean
}

const load = (): State => {
  return {
    cookies: VueCookieNext.isCookieAvailable("cookies_consent")
  }
}

export const usePermissionStore = defineStore("permission", {
  state: () => {
    const state = load()
    return state
  },
  actions: {
    setCookies(cookies: boolean) {
      this.cookies = cookies
      
      if(cookies === true) {
        VueCookieNext.setCookie("cookies_consent", `${DateTime.now().toMillis()}`)
      }
      else {
        VueCookieNext.removeCookie("cookies_consent")
      }
    }
  }
})
